import { useEffect } from 'react';

import { useUserData } from '@givebacks/api/core';
import { useAtom } from 'jotai';
import { useSearchParams } from 'react-router-dom';

import { UserFeatureFlags } from '../flags.types';
import { useUserReleaseControl } from '../user/releaseControl';
import { previewAtom } from './userFlagsAtoms';

const useUserRelease = (feature: UserFeatureFlags) => {
  const { accessStatus, isLoading } = useUserReleaseControl({
    feature: feature,
  });
  return { isEnabled: !!accessStatus, isLoading };
};

const useUserInternalPreview = () => {
  const [search] = useSearchParams();
  const { data: user, isLoading } = useUserData();
  const [isEnabled, setIsPreview] = useAtom(previewAtom);

  useEffect(
    () => {
      if (user?.internal) {
        setIsPreview(isEnabled || search.get('preview') == 'true');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.internal]
  );

  return { isEnabled, isLoading };
};

const useUserReleaseStudentFees = () => useUserRelease('user.studentFees');

export { useUserInternalPreview, useUserReleaseStudentFees };
